export default __webpack_public_path__ + "static/media/Subaru-logo-vertical-white.eb2befa8.png";